import { Log } from '../../../AuxillaryService/Log';

export const GlobalLog = {
    Debug(message: string, code?: string, source?: string, data?: unknown): void {
        Log.Debug(message, code, source, data);
    },

    Info(message: string, code?: string, source?: string, data?: unknown): void {
        Log.Info(message, code, source, data);
    },

    Notice(message: string, code?: string, source?: string, data?: unknown): void {
        Log.Notice(message, code, source, data);
    },

    Warning(message: string, code?: string, source?: string, data?: unknown): void {
        Log.Warning(message, code, source, data);
    },

    Error(message: string, code?: string, source?: string, data?: unknown): void {
        Log.Error(message, code, source, data);
    },

    Critical(message: string, code?: string, source?: string, data?: unknown): void {
        Log.Critical(message, code, source, data);
    },
};
